import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types";
import { TGlobalSearchProviderContext } from "./provider.types";

export const createTutoresProvider = (ctx: TGlobalSearchProviderContext): ISearchProvider => {
    return {
        key: "tutores",
        label: "Tutores",
        subLabel: "Gestión de tutores",
        action: ctx.navigateModule("alumnos/tutores"),
        search: (): ISearchResult[] => ([])
    };
};